(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define("lmmMapsWidget", ["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["lmmMapsWidget"] = factory(require("jQuery"));
	else
		root["lmmMapsWidget"] = factory(root["jQuery"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition